import {AxisBottom} from '@visx/axis';
import React, {FC} from 'react';

import {useUserTheme} from '../../../../../../libs/shared/ui/src/theme/userThemeProvider';
import {AxisProps, DEFAULT_TICK_LABEL_PROPS, findTickLabelFillColor} from './commons';

// eslint-disable-next-line @typescript-eslint/naming-convention
interface XAxisProps extends AxisProps {
  top?: number;
  hideAxisLine?: boolean;
}

export const XAxis: FC<XAxisProps> = ({scale, hideTickValues, tickFormat, hideAxisLine, top, numTicks}) => {
  const theme = useUserTheme();

  return (
    <AxisBottom
      top={top}
      scale={scale}
      stroke={theme.greys.shade30}
      hideAxisLine={hideAxisLine}
      hideTicks
      tickLabelProps={() => ({
        ...DEFAULT_TICK_LABEL_PROPS,
        fill: findTickLabelFillColor(theme),
        textAnchor: 'middle',
      })}
      tickValues={hideTickValues ? [] : undefined}
      tickFormat={tickFormat}
      numTicks={numTicks || undefined}
    />
  );
};

export const X_AXIS_HEIGHT = 30;
